<script setup>

import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
      <div>
        <el-form-item label="临时措施" prop="provisionalMeasures">
          <el-input :disabled="provisionalMeasures!==undefined" placeholder="请输入临时措施" v-model="form.provisionalMeasures" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="auditPassBtClick">升级到质量中心</el-button>
        <el-button plain @click="auditRejectBtClick">结束流程</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-dialog width="600px !important" title="处理意见" :visible.sync="handResultDialogVisible">
        <el-form :model="form" :rules="rules" ref="handSuggestionFormRef" label-width="85px">
          <el-form-item label="处理意见" prop="handSuggestion">
            <el-input v-model="form.handSuggestion" type="textarea" placeholder="请输入处理意见" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="submitResultForm()">{{resultType == 1?'升级到质量中心':'结束流程'}}</el-button>
            <el-button plain @click="handResultDialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {baseURL} from "../../util/url";
import {requestSubmitAuditKD} from "@/api/feedbackKD";

/**
 * 5.1-质量经理审批
 */
export default {
  name: "kdQualityManagerUpgradeAudit",
  inject: ['getValidateForm'],
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    endProcess:Boolean,
    provisionalMeasures:String,
    suggestionItems: {
      type: Array,
      default: () => []  // 默认值使用工厂函数返回空数组
    },
    disableForm:{
      type: Boolean,
      default: false
    },
    // taskId:String,
    receivedForm:{
      provisionalMeasures:{
        type: String,
        default: ""
      }
    }
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      resultType:1,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible:false,
      handResultDialogVisible:false,
      form:{
        requestCompletionProcess: 0,
        provisionalMeasures:"",
        handSuggestion: ""
      },
      rules: {
        provisionalMeasures: [
          {
            required: true, message: "临时措施不能为空", trigger: ["blur", "change"]
          }
        ],
        handSuggestion: [
          {
            required: true, message: "处理意见不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    }
  },
  methods: {
    submitResultForm() {
      this.$refs['handSuggestionFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        if(this.resultType === 1){
          this.submitPassResultForm()
        }else{
          this.submitRejectResultForm()
        }
      })
    },
    submitPassResultForm(){
      this.$confirm('确定升级到质量中心吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.handSuggestion,
          variables: {
            approval: true,
            upgrade: true,
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('审批通过!');
            this.backRouterPath();
          }
        })
      })
    },
    async auditPassBtClick() {
      if (!await this.getValidateForm()) {
        return
      }
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.resultType = 1;
        this.handResultDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.handSuggestionFormRef?.resetFields();
        })
      })
    },
    auditRejectBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.resultType = 2;
        this.handResultDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.handSuggestionFormRef?.resetFields();
        })
      })
    },
    submitRejectResultForm(){
    this.$confirm('确定结束流程吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
        }).then(() => {
          this.auditRejectSubmit();
        })
      },
    auditRejectSubmit(){
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.handSuggestion,
          variables: {
            approval: true,
            upgrade: false,
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        })
    }
  },
  mounted() {
    this.form.provisionalMeasures = this.provisionalMeasures??"";
    console.log(this.form.suggestionItems)
  }
}
</script>
